/**************************************************
 * Nombre:       Formulario_Cuenta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, DiamondOutlined, Flag, NotificationsOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {RANGOSCUENTA} from "../../Constantes";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";

const Formulario_Cuenta = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Rango'} dato={'rango'} {...props}
                                   opciones={RANGOSCUENTA}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'El Nombres es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'El Apellido es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={BadgeOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={DiamondOutlined} nombre={'Dimante Superior'} dato={'diamante'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={NotificationsOutlined} nombre={'Notificaciones WhatsApp'} dato={'notificaciones'} {...props}
                                   opciones={['Si', 'No']}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Cuenta